import { useEffect } from 'react';
import { companyInfo, cities, services } from '../../data/mock';

// Base URL pour les canonicals (sans www)
const BASE_URL = 'https://www.menuisiervitrier.fr';

// SEO data optimisé pour vitrerie Villiers-sur-Marne et Val-de-Marne (94)
export const seoData = {
  home: {
    title: "Vitrier Villiers-sur-Marne (94) | Urgence 24h/24 | NGL SERVICES",
    description: "Vitrier miroitier à Villiers-sur-Marne 94350 ☎ 07 81 55 90 50. Remplacement de vitre, bris de glace, double vitrage, baie vitrée. Dépannage vitrerie urgence 24h/24. Val-de-Marne. Devis GRATUIT.",
    keywords: "vitrier villiers-sur-marne, vitrier à villiers, vitrier miroitier, vitrerie à villiers, villiers sur marne 94350, bris de glace, remplacement de vitre, double vitrage, vitres cassées, baie vitrée, dépannage vitrerie, val de marne, île de france, champigny sur marne, savoir faire, vitrier 94"
  },
  vitrerie: {
    title: "Vitrier Urgence Villiers-sur-Marne | 24h/24",
    description: "Vitrier urgence à Villiers-sur-Marne ☎ 07 81 55 90 50. Spécialiste remplacement vitre cassée, bris de glace, double vitrage, triple vitrage. Intervention rapide 24h/24. Devis gratuit.",
    keywords: "vitrier villiers-sur-marne, vitre cassée villiers-sur-marne, bris de glace 94, remplacement vitrage, double vitrage rénovation, vitrier urgence 94, dépannage vitrerie val-de-marne, artisan vitrier 94350, miroitier villiers-sur-marne, vitrage sécurit, verre feuilleté, carreau double vitrage, vitrerie à proximité"
  },
  about: {
    title: "À Propos | NGL SERVICES Vitrier 94",
    description: "NGL SERVICES, vitrier miroitier à Villiers-sur-Marne (94). Équipe qualifiée, savoir-faire reconnu. Intervention rapide vitre cassée et bris de glace. Urgences 24h/24. ☎ 07 81 55 90 50",
    keywords: "NGL SERVICES, vitrier Val-de-Marne, vitrier miroitier 94, entreprise vitrerie villiers-sur-marne, savoir faire vitrerie"
  },
  contact: {
    title: "Contact & Devis | Vitrier Villiers-sur-Marne",
    description: "Contactez NGL SERVICES pour un devis gratuit vitrerie à Villiers-sur-Marne. Remplacement de vitre, bris de glace. ☎ 07 81 55 90 50. Dépannage vitrerie urgence 24h/24.",
    keywords: "devis vitrier gratuit, contact vitrier 94, urgence vitrerie villiers-sur-marne, vitrier champigny, vitrier bry-sur-marne"
  }
};

// Fonction pour générer l'URL canonical
export const getCanonicalUrl = (path = '') => {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${BASE_URL}${cleanPath === '/' ? '' : cleanPath}`;
};

// Generate service SEO data
export const getServiceSeo = (serviceId) => {
  const service = services.find(s => s.id === serviceId);
  if (!service) return seoData.home;
  
  if (serviceId === 'vitrerie') {
    return seoData.vitrerie;
  }
  
  return {
    title: `${service.title} Villiers-sur-Marne | Devis Gratuit`,
    description: `${service.description} Intervention rapide à Villiers-sur-Marne et Val-de-Marne. Urgences 24h/24 ☎ ${companyInfo.phoneEmergency}`,
    keywords: service.seoKeywords ? service.seoKeywords.join(', ') : `${service.title.toLowerCase()}, Villiers-sur-Marne, Val-de-Marne, 94`
  };
};

// Generate city SEO data - Optimisé vitrerie Val-de-Marne
export const getCitySeo = (cityId) => {
  const city = cities.find(c => c.id === cityId);
  if (!city) return seoData.home;
  
  // SEO optimisé par ville avec mots-clés locaux
  const cityKeywords = {
    'villiers-sur-marne': 'vitrier villiers-sur-marne, vitre cassée villiers-sur-marne, bris de glace 94350, double vitrage villiers-sur-marne, miroitier villiers-sur-marne, vitrier urgence villiers-sur-marne, artisan vitrier 94350, vitrerie villiers-sur-marne',
    'champigny-sur-marne': 'vitrier champigny-sur-marne, vitre cassée champigny, bris de glace 94500, double vitrage champigny, vitrier urgence champigny, artisan vitrier champigny',
    'bry-sur-marne': 'vitrier bry-sur-marne, vitre cassée bry-sur-marne, bris de glace 94360, double vitrage bry-sur-marne, vitrier urgence bry',
    'nogent-sur-marne': 'vitrier nogent-sur-marne, vitre cassée nogent, bris de glace 94130, double vitrage nogent, vitrier urgence nogent',
    'le-perreux-sur-marne': 'vitrier le-perreux-sur-marne, vitre cassée le perreux, bris de glace 94170, vitrier urgence le perreux',
    'saint-maur-des-fosses': 'vitrier saint-maur-des-fossés, vitre cassée saint-maur, bris de glace 94100, vitrier urgence saint-maur',
    'creteil': 'vitrier créteil, vitre cassée créteil, bris de glace 94000, double vitrage créteil, vitrier urgence créteil',
    'noisy-le-grand': 'vitrier noisy-le-grand, vitre cassée noisy, bris de glace 93160, vitrier urgence noisy-le-grand',
    'neuilly-sur-marne': 'vitrier neuilly-sur-marne, vitre cassée neuilly-sur-marne, bris de glace 93330, vitrier urgence neuilly',
    'neuilly-plaisance': 'vitrier neuilly-plaisance, vitre cassée neuilly-plaisance, bris de glace 93360',
    'gournay-sur-marne': 'vitrier gournay-sur-marne, vitre cassée gournay, bris de glace 93460',
    'le-plessis-trevise': 'vitrier le-plessis-trévise, vitre cassée plessis-trévise, bris de glace 94420',
    'chennevieres-sur-marne': 'vitrier chennevières-sur-marne, vitre cassée chennevières, bris de glace 94430',
    'torcy': 'vitrier torcy, vitre cassée torcy, bris de glace 77200'
  };
  
  if (cityId === 'villiers-sur-marne') {
    return {
      title: `Vitrier Villiers-sur-Marne (94350) | Urgence 24h/24`,
      description: `Vitrier à Villiers-sur-Marne ☎ 07 81 55 90 50. Remplacement vitre cassée, bris de glace, double vitrage. Artisan vitrier urgence 24h/24. Intervention rapide. Devis GRATUIT.`,
      keywords: cityKeywords['villiers-sur-marne']
    };
  }
  
  return {
    title: `Vitrier ${city.name} (${city.postalCode}) | Urgence 24h/24`,
    description: `Vitrier à ${city.name}. Remplacement vitre cassée, bris de glace, double vitrage. Intervention rapide. ☎ ${companyInfo.phone}. Devis gratuit.`,
    keywords: cityKeywords[cityId] || `vitrier ${city.name}, vitre cassée ${city.name}, bris de glace ${city.postalCode}, vitrerie ${city.name}, vitrier urgence ${city.postalCode}`
  };
};

// LocalBusiness Schema.org - Optimisé vitrerie
export const getLocalBusinessSchema = () => {
  const areasServed = cities.map(city => ({
    "@type": "City",
    "name": city.name,
    "postalCode": city.postalCode
  }));

  return {
    "@context": "https://schema.org",
    "@type": ["LocalBusiness", "HomeAndConstructionBusiness"],
    "@id": "https://ngl-services.fr/#organization",
    "name": "NGL SERVICES - Vitrier Villiers-sur-Marne",
    "alternateName": ["NGL SERVICES Vitrerie", "Vitrier NGL SERVICES"],
    "image": companyInfo.logo,
    "description": "Vitrier à Villiers-sur-Marne. Spécialiste remplacement vitre cassée, bris de glace, double vitrage. Urgence 24h/24. Artisan vitrier qualifié.",
    "url": "https://ngl-services.fr",
    "telephone": companyInfo.phoneEmergency,
    "email": companyInfo.email,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Villiers-sur-Marne",
      "addressLocality": "Villiers-sur-Marne",
      "postalCode": "94350",
      "addressRegion": "Val-de-Marne",
      "addressCountry": "FR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 48.8273,
      "longitude": 2.5449
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
        "opens": "00:00",
        "closes": "23:59",
        "description": "Service urgence vitrerie 24h/24"
      }
    ],
    "priceRange": "€€",
    "currenciesAccepted": "EUR",
    "paymentAccepted": "Cash, Credit Card, Bank Transfer",
    "areaServed": areasServed,
    "serviceArea": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": 48.8273,
        "longitude": 2.5449
      },
      "geoRadius": "20000"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Services Vitrerie et Menuiserie",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Remplacement vitre cassée",
            "description": "Remplacement de vitre cassée en urgence à Villiers-sur-Marne"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Réparation bris de glace",
            "description": "Intervention bris de glace 24h/24"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Installation double vitrage",
            "description": "Pose double vitrage isolant thermique et phonique"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Vitrier urgence 24h/24",
            "description": "Service d'urgence vitrerie disponible 24h/24 et 7j/7"
          }
        }
      ]
    },
    "knowsAbout": [
      "Vitrerie",
      "Remplacement vitre",
      "Bris de glace",
      "Double vitrage",
      "Triple vitrage",
      "Menuiserie extérieure",
      "Serrurerie"
    ],
    "slogan": "Vitrier Villiers-sur-Marne - Urgence 24h/24",
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "telephone": companyInfo.phone,
        "contactType": "customer service",
        "areaServed": "FR",
        "availableLanguage": "French"
      },
      {
        "@type": "ContactPoint",
        "telephone": companyInfo.phoneEmergency,
        "contactType": "emergency",
        "hoursAvailable": {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
          "opens": "00:00",
          "closes": "23:59"
        },
        "availableLanguage": "French"
      }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "127",
      "bestRating": "5",
      "worstRating": "1"
    }
  };
};

// Service Schema for vitrerie page
export const getVitrerieServiceSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Vitrier Villiers-sur-Marne - Vitrerie",
    "alternateName": ["Remplacement vitre cassée", "Réparation bris de glace", "Installation double vitrage"],
    "description": "Service de vitrerie professionnel à Villiers-sur-Marne. Remplacement vitre cassée, bris de glace, double vitrage, triple vitrage. Urgence 24h/24.",
    "provider": {
      "@type": "LocalBusiness",
      "name": "NGL SERVICES",
      "telephone": companyInfo.phoneEmergency,
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Villiers-sur-Marne",
        "postalCode": "94350",
        "addressCountry": "FR"
      }
    },
    "areaServed": cities.map(city => ({
      "@type": "City",
      "name": city.name
    })),
    "serviceType": "Vitrerie",
    "termsOfService": "Devis gratuit, intervention rapide",
    "offers": {
      "@type": "Offer",
      "availability": "https://schema.org/InStock",
      "priceSpecification": {
        "@type": "PriceSpecification",
        "priceCurrency": "EUR"
      }
    }
  };
};

// FAQ Schema for SEO
export const getFAQSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Comment contacter un vitrier en urgence à Villiers-sur-Marne ?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Pour une urgence vitrerie à Villiers-sur-Marne, appelez NGL SERVICES au 07 81 55 90 50. Notre vitrier intervient 24h/24 et 7j/7 pour tout remplacement de vitre cassée ou bris de glace."
        }
      },
      {
        "@type": "Question",
        "name": "Quel est le délai d'intervention d'un vitrier à Villiers-sur-Marne ?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "NGL SERVICES garantit une intervention rapide en moins d'une heure à Villiers-sur-Marne et ses environs pour les urgences vitrerie."
        }
      },
      {
        "@type": "Question",
        "name": "Combien coûte le remplacement d'une vitre cassée ?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Le tarif dépend du type de vitrage (simple, double, triple) et des dimensions. NGL SERVICES propose un devis gratuit et sans engagement avant toute intervention."
        }
      },
      {
        "@type": "Question",
        "name": "Intervenez-vous pour un bris de glace le dimanche ?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Oui, NGL SERVICES intervient 7j/7, y compris les dimanches et jours fériés, pour tout bris de glace ou vitre cassée à Villiers-sur-Marne."
        }
      }
    ]
  };
};

// SEO Component — applique les balises directement dans le <head> (fiable sous React 19,
// react-helmet-async n'appliquant pas les <meta> de façon fiable ici).
const _setMeta = (attr, key, content) => {
  if (content == null || content === "") return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const _setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const SEO = ({
  title,
  description,
  keywords,
  canonical,
  ogImage,
  noindex = false,
  schemaData = null,
  additionalSchemas = [],
}) => {
  const baseUrl = "https://www.menuisiervitrier.fr";
  const canonicalUrl = canonical ? getCanonicalUrl(canonical) : baseUrl;
  const image = ogImage || companyInfo.logo;

  useEffect(() => {
    if (title) document.title = title;
    _setMeta("name", "description", description);
    if (keywords) _setMeta("name", "keywords", keywords);
    _setMeta(
      "name",
      "robots",
      noindex
        ? "noindex, nofollow"
        : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
    );
    _setCanonical(canonicalUrl);
    _setMeta("property", "og:type", "website");
    _setMeta("property", "og:title", title);
    _setMeta("property", "og:description", description);
    _setMeta("property", "og:image", image);
    _setMeta("property", "og:url", canonicalUrl);
    _setMeta("property", "og:site_name", "NGL SERVICES - Vitrier Villiers-sur-Marne");
    _setMeta("property", "og:locale", "fr_FR");
    _setMeta("name", "twitter:card", "summary_large_image");
    _setMeta("name", "twitter:title", title);
    _setMeta("name", "twitter:description", description);
    _setMeta("name", "twitter:image", image);

    // JSON-LD : remplacer les scripts gérés
    document.head.querySelectorAll("script[data-seo-jsonld]").forEach((s) => s.remove());
    const addLd = (obj) => {
      if (!obj) return;
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo-jsonld", "1");
      s.text = JSON.stringify(obj);
      document.head.appendChild(s);
    };
    addLd(schemaData);
    (additionalSchemas || []).forEach(addLd);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, keywords, canonical, noindex, image]);

  return null;
};

export default SEO;
